// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + {"278":"ProductGallery","898":"ModalButton"}[chunkId] + "." + {"278":"7ab2abd6","898":"c73d70bd"}[chunkId] + ".css";
};